<template>
<div class="index-content">
  <div class="container">
    <h3>企业文化</h3>
    <p>因为友爱，所以有希望；因为有希望，所以有爱。</p>
    <p>我们不忘初心牢记使命，以正确的世界观、人生观、价值现为准则，以爱为原则，以梦想为寄托，乐观的、激情四射的向前冲。</p>
    <ul class="index-list" v-if="!imgs.length">
      <li>
        <div class="img">
          <img src="../assets/images/culture_1.png" alt="">
          <div class="con">
            <h3>赋能计划</h3>
            <p>不忘初心牢记使命，以正确的世界观</p>
          </div>
        </div>
      </li>
      <li>
        <div class="img">
          <img src="../assets/images/culture_2.png" alt="">
          <div class="con">
            <h3>赋能计划</h3>
            <p>不忘初心牢记使命，以正确的世界观</p>
          </div>
        </div>
      </li>
      <li>
        <div class="img">
          <img src="../assets/images/culture_3.png" alt="">
          <div class="con">
            <h3>赋能计划</h3>
            <p>不忘初心牢记使命，以正确的世界观</p>
          </div>
        </div>
      </li>
    </ul>
    <ul class="index-list"  v-else>
      <li v-for="item,index in imgs" :key='index'>
        <div class="img">
          <img :src="imgUrl + item.pic" alt="" class="imgsize">
          <div class="con">

          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
const imgUrl = "https://ringstar.xhqj71.com/jeecg-boot/sys/common/static/"; //公共路径 

import {
  banner
} from "../api/api"

export default {

  data() {
    return {
      imgUrl: imgUrl,
      imgs:[],
    }
  },
  mounted() {

    this.getbanner();

  },
  methods: {
    getbanner() {
      banner({
        type: 4
      }).then(res => {
        if (res.data.code == 200) {

         this.imgs = res.data.result

        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.index-content {
  padding: 95px 0 160px;
  background: #e8f1fa url("~@/assets/images/culture_bg.jpg") no-repeat;

  h3 {
    margin-bottom: 40px;
  }
}

.index-list {
  margin-top: 60px;

  li {
    flex: 0 0 32%;
    margin-right: calc(3% / 2);
    margin-bottom: calc(3% / 2);

    &:nth-child(3n) {
      margin-right: 0;
    }

    .con {
      position: absolute;
      top: 40px;
      left: 45px;

      h3 {
        text-align: left;
        margin-bottom: 5px;
        font-size: 28px;
        color: #11f1f5;
      }

      p {
        font-size: 16px;
        color: #ffffff;
      }
    }
  }
}
.imgsize {
  width: 400px;
  height: 245px;
}
</style>



// WEBPACK FOOTER //
// src/components/culture.vue